import React, { Component } from "react";
import { withRouter } from 'react-router-dom';

import { withStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from "@material-ui/core/CardContent";
import DeviceGroupPollForm from "./DeviceGroupPollForm";
import AppDeviceGroupPollStore from "../../stores/AppDeviceGroupPollStore";

const styles = {
  card: {
    overflow: "visible",
  },
};


class UpdateDeviceGroupPoll extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(deviceGroupPoll) {
    AppDeviceGroupPollStore.update(deviceGroupPoll, resp => {
      this.props.history.push(`/organizations/${this.props.match.params.organizationID}/applications/${this.props.match.params.applicationID}/device-groups/${this.props.match.params.deviceGroupID}/polls`);
    });
  }

  render() {
    return(
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Card className={this.props.classes.card}>
            <CardContent>
              <DeviceGroupPollForm
                submitLabel="Update device type poll"
                object={this.props.deviceGroupPoll}
                onSubmit={this.onSubmit}
                match={this.props.match}
                update={true}
                disabled={!this.props.admin}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(withRouter(UpdateDeviceGroupPoll));
